import { render, staticRenderFns } from "./stock-details.vue?vue&type=template&id=a2bb2cc4&scoped=true&"
import script from "./stock-details.vue?vue&type=script&lang=js&"
export * from "./stock-details.vue?vue&type=script&lang=js&"
import style0 from "./stock-details.vue?vue&type=style&index=0&id=a2bb2cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bb2cc4",
  null
  
)

export default component.exports